/**
 * @param {object} item - Item
 * @param {object[]} columns - Column data
 * @param {number[]} number - qualifierRow
 * @param finalsCutOff
 * @param topFinalsCutOff
 * @param conferenceLabel
 * @param premWinner
 * @param competitionId
 * @param compSeasonId
 * @param roundId
 * @param roundNumber
 * @param competitionType
 * @param favouriteTeam
 * @returns {object[]} qualifierRow - row data
 */
export const composeRowData = (
    item,
    columns,
    finalsCutOff,
    topFinalsCutOff,
    conferenceLabel,
    premWinner,
    competitionId,
    compSeasonId,
    roundNumber,
    competitionType,
    favouriteTeam
) => {
    let rowData = {};
    columns.forEach((column) => {
        const accessor = column.accessor;

        if (item?.[accessor]) {
            rowData[accessor] = item[accessor];
        }
    });

    rowData.clubName = item?.club;
    rowData.isFavourite =
        rowData.clubName?.abbreviation.toLowerCase() === favouriteTeam &&
        (competitionType === 'AFL' || competitionType === 'AFLW');
    rowData.isConference = conferenceLabel ? true : false;
    rowData.premWinner = premWinner || false;
    rowData.competitionId = competitionId;
    rowData.compSeasonId = compSeasonId;
    rowData.roundNumber = roundNumber;
    rowData.byeUpNext = item?.byeUpNext || false;
    rowData.competitionType = competitionType;

    // Calculate cutoff positions

    // If wildcard (top cutoff exists)
    if (topFinalsCutOff) {
        rowData.firstCutOff = Math.min(finalsCutOff, topFinalsCutOff);
        rowData.secondCutOff = Math.max(finalsCutOff, topFinalsCutOff);
    } else {
        // Else non-wildcard comp
        rowData.firstCutOff = finalsCutOff;
    }

    return rowData;
};
